import React from 'react';

const PrivacyLegislation = () => {
  return (
    <svg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M36.4131 29.8553V29.1323H19.7631V29.8553H36.4131Z' fill='#2481C4' />
      <path d='M36.4131 33.0568V32.3337H19.7631V33.0568H36.4131Z' fill='#2481C4' />
      <path d='M36.4131 36.2594V35.5364H19.7631V36.2594H36.4131Z' fill='#2481C4' />
      <path d='M36.4131 39.4613V38.7383H19.7631V39.4613H36.4131Z' fill='#2481C4' />
      <path d='M30.0098 42.6627V41.9397H19.7637V42.6627H30.0098Z' fill='#2481C4' />
      <path
        d='M33.2115 11.2014H36.5365C39.2979 11.2014 41.5365 13.44 41.5365 16.2014V43.3437C41.5365 46.1051 39.2979 48.3437 36.5365 48.3437H19C16.2386 48.3437 14 46.1051 14 43.3437V16.2014C14 13.44 16.2386 11.2014 19 11.2014H22.325'
        stroke='#2481C4'
      />
      <path
        d='M29.4495 9.83361L29.5029 10.2734H29.9459H31.6626C32.641 10.2734 33.3528 10.9856 33.3528 11.7684C33.3528 12.5512 32.641 13.2635 31.6626 13.2635H23.8756C22.8972 13.2635 22.1855 12.5512 22.1855 11.7684C22.1855 10.9856 22.8972 10.2734 23.8756 10.2734H25.5924H26.0354L26.0887 9.83361C26.1754 9.11968 26.8604 8.5 27.7691 8.5C28.6778 8.5 29.3629 9.11968 29.4495 9.83361Z'
        stroke='#2481C4'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M26.3087 17.1057H26.8087H29.3702H29.8702V17.6057V19.6673H31.9317H32.4317V20.1673V22.7289V23.2289H31.9317H29.8702V25.2903V25.7903H29.3702H26.8087H26.3087V25.2903V23.2289H24.2471H23.7471V22.7289V20.1673V19.6673H24.2471H26.3087V17.6057V17.1057ZM27.3087 18.1057V20.1673V20.6673H26.8087H24.7471V22.2289H26.8087H27.3087V22.7289V24.7903H28.8702V22.7289V22.2289H29.3702H31.4317V20.6673H29.3702H28.8702V20.1673V18.1057H27.3087Z'
        fill='#2481C4'
      />
    </svg>
  );
};

PrivacyLegislation.displayName = 'PrivacyLegislation';

export default PrivacyLegislation;
